import { StyledPaper, Title, Text, StyledAlert } from './ThirdPartyInfo.styles';
import ThirdPartyInfoCopy from './ThirdPartyInfo.copy';

const { title, text, info } = ThirdPartyInfoCopy;

const ThirdPartyInfo = () => (
  <StyledPaper>
    <Title variant="h5">{title}</Title>
    <Text>{text}</Text>
    <StyledAlert type="info" text={info} />
  </StyledPaper>
);

export default ThirdPartyInfo;
